import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Chip } from '@mui/material';
import React, { useCallback } from 'react';
import { Icons } from '../../icons/Icons';
import { SortableChipProps } from './types';

export default function SortableChip({ chip, chipId, tagProps, isFixed, chipSx, onChipClick }: SortableChipProps) {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
        id: chipId,
        disabled: isFixed
    });
    const style = {
        ...tagProps.style,
        transform: CSS.Transform.toString(transform),
        transition
    };
    const handleClick = useCallback(
        (event) => {
            tagProps.onClick?.(event);
            onChipClick?.(chip, chipId);
        },
        [chip, chipId, onChipClick, tagProps]
    );

    return (
        <Chip
            ref={setNodeRef}
            {...tagProps}
            size={tagProps.size || 'medium'}
            icon={isFixed ? undefined : <Icons.DragIndicator />}
            clickable={!isFixed}
            label={chip.label}
            onDelete={isFixed ? undefined : tagProps.onDelete}
            style={style}
            sx={chipSx}
            onClick={handleClick}
            {...(isFixed ? {} : { ...attributes, ...listeners })}
        />
    );
}
